import React, { useContext } from 'react';
import { DragDropContext, Draggable, Droppable, DropResult } from 'react-beautiful-dnd';
import Item from './components/Item';
import {
	ChangeDishPositionContext,
	IChangeDishPositionContext,
} from '../../../../../../changeDishPositionState/changeDishPositionContext';
import style from './DnDList.module.scss';

const DnDList: React.FC = () => {
	const { reorderItems, positionsData } = useContext<IChangeDishPositionContext>(ChangeDishPositionContext);

	const handleDragEnd = (result: DropResult) => {
		if (!positionsData || !result.destination) {
			return null;
		}
		const items = positionsData;
		const [reorderedItem] = items.splice(result.source.index, 1);
		items.splice(result.destination.index, 0, reorderedItem);
		reorderItems(items);
	};

	return (
		<DragDropContext onDragEnd={handleDragEnd}>
			<Droppable droppableId="dishesList">
				{(provided) => (
					<div
						className={style.items}
						ref={provided.innerRef}
						{...provided.droppableProps}
						data-test="DnDList">
						{positionsData.map((item, index) => (
							<Draggable key={item.id} draggableId={item.id} index={index}>
								{(provided) => (
									<div ref={provided.innerRef} {...provided.draggableProps}>
										<Item
											data={item}
											positionNumber={index + 1}
											dragHandleProps={provided.dragHandleProps}
										/>
									</div>
								)}
							</Draggable>
						))}
						{provided.placeholder}
					</div>
				)}
			</Droppable>
		</DragDropContext>
	);
};

export default DnDList;
